





import { CheckIn } from '@/modules/servis/checkIn';
import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { store } from '../../store/edit';
import { types } from '../../store/types';
import { NAME as VOZIDLO_CHECKIN } from '../../../checkIn/constants';

export default Vue.extend({
	name: 'ZakazkaCheckInSelect',
	components: {
		CheckInSelect: CheckIn.components.Select,
	},
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.CHECK_IN_SELECT}`,
			};
		},
		checkInFilter() {
			return {
				VozidloId: this.VozidloId,
				VozidloSpz: this.VozidloRzv,
				KaroserieNr: this.VozidloVin,
				ZakaznikId: this.ZakaznikId,
				ZakazkaId: this.ZakazkaId,
				CheckinNr: this.CheckinNr,
			};
		},
	},
	methods: {
		checkInChange(data: any) {
			if (data.CheckinVstupDat) {
				this.CheckinVstupDat = data.CheckinVstupDat;
				this.CheckinId = data.CheckinId;
			}
		},
		openEditCheckIn() {
			openEdit(VOZIDLO_CHECKIN, PageMode.EDIT, { id: this.CheckinId! });
		},
	},
});
